import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import SEO from "@/components/SEO";

// Lazy-load below-the-fold sections to shrink initial JS and speed LCP
const TestimonialsCarousel = lazy(() => import("@/components/TestimonialsCarousel"));
const StatsBar = lazy(() => import("@/components/StatsBar"));
const Demographics = lazy(() => import("@/components/Demographics"));
const Showcase = lazy(() => import("@/components/Showcase"));
const WhyDinerTV = lazy(() => import("@/components/WhyDinerTV"));
const Locations = lazy(() => import("@/components/Locations"));
const Pricing = lazy(() => import("@/components/Pricing"));
const FAQ = lazy(() => import("@/components/FAQ"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Fallback = () => <div className="min-h-[200px]" aria-hidden="true" />;

const Index = () => (
  <div className="min-h-screen bg-[var(--color-bg)] pb-[72px] md:pb-0">
    <SEO
      title="Long Island TV Advertising for Local Businesses | TableTalk TV"
      description="Reach 30,000+ Long Island homeowners a month. 30-second ads on 60&quot; diner TVs in Nassau & Suffolk. From under $10/day."
      path="/"
    />
    <Navbar />
    <Hero />
    <HowItWorks />
    <Suspense fallback={<Fallback />}>
      <TestimonialsCarousel />
      <StatsBar />
      <Demographics />
      <Showcase />
      <WhyDinerTV />
      <Locations />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </Suspense>
    <StickyMobileCTA />
  </div>
);

export default Index;
